window.isueinstant = function () {

    const svgWidth = 400;
    const svgHeight = 350;
    const centerX = svgWidth / 2;
    const centerY = svgHeight / 2;

    var instance = {
        vectorDiagram: function (args) {

            const data = {
                Ua: args.data.phaseVoltageA,
                Ub: args.data.phaseVoltageB,
                Uc: args.data.phaseVoltageC,
                Ia: args.data.phaseCurrentA,
                Ib: args.data.phaseCurrentB,
                Ic: args.data.phaseCurrentC,
                cosPhiA: args.data.factorCosPhasePowerA,
                cosPhiB: args.data.factorCosPhasePowerB,
                cosPhiC: args.data.factorCosPhasePowerC,
                powerReactiveDirectA: args.data.powerReactiveDirectA,
                powerReactiveDirectB: args.data.powerReactiveDirectB,
                powerReactiveDirectC: args.data.powerReactiveDirectC,
                powerReactiveReverseA: args.data.powerReactiveReverseA,
                powerReactiveReverseB: args.data.powerReactiveReverseB,
                powerReactiveReverseC: args.data.powerReactiveReverseC
            };
            
            let Umax = Math.max(data.Ua, data.Ub, data.Uc, 1)
            let Imax = Math.max(data.Ia, data.Ib, data.Ic, 0.01)
            
            var id = 'isue_instantviews_diagram';
            d3.select("#" + id + " svg").remove();
            var svg = d3.select("#" + id)
                .append("svg")
                .attr("width", svgWidth)
                .attr("height", svgHeight);

            svg.append("defs")
                .append("marker")
                .attr("id", "arrow")
                .attr("viewBox", "0 0 10 10")
                .attr("refX", "5")
                .attr("refY", "5")
                .attr("markerWidth", "4")
                .attr("markerHeight", "4")
                .attr("orient", "auto-start-reverse")
                .append("path")
                .attr("d", "M 0 0 L 10 5 L 0 10 z")
                .attr("fill", "black");

            function addDegreeMarks() {
                const angles = [0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330];
                const markRadius = 155;
                const innerRadius = 0;

                angles.forEach(angle => {
                    const angleRad = (angle * Math.PI) / 180;

                    svg.append("line")
                        .attr("x1", centerX + innerRadius * Math.sin(angleRad))
                        .attr("y1", centerY - innerRadius * Math.cos(angleRad))
                        .attr("x2", centerX + markRadius * Math.sin(angleRad))
                        .attr("y2", centerY - markRadius * Math.cos(angleRad))
                        .attr("fill", "none")
                        .attr("stroke", "#ccc")
                        .attr("stroke-dasharray", "2,2");

                    const textRadius = markRadius + 15;
                    const textAngleRad = angle * Math.PI / 180;

                    svg.append("text")
                        .attr("x", centerX + textRadius * Math.sin(textAngleRad))
                        .attr("y", centerY - textRadius * Math.cos(textAngleRad))
                        .attr("font-size", "10px")
                        .attr("stroke", "white")
                        .attr("stroke-width", "2px")
                        .attr("stroke-opacity", "0.7")
                        .attr("paint-order", "stroke")
                        .attr("text-anchor", "middle")
                        .attr("alignment-baseline", "middle")
                        .text(angle + "°");
                });
            }


            function drawVector(length, angleDeg, color, label, width) {
                const angleRad = angleDeg * Math.PI / 180;
                const arrowSize = 5;
                const effectiveLength = length - arrowSize;
                const x2 = centerX + effectiveLength * Math.sin(angleRad);
                const y2 = centerY - effectiveLength * Math.cos(angleRad);

                svg.append("line")
                    .attr("x1", centerX)
                    .attr("y1", centerY)
                    .attr("x2", x2)
                    .attr("y2", y2)
                    .attr("stroke", color)
                    .attr("stroke-width", width)
                    .attr("marker-end", "url(#arrow)");

                const textOffsetX = -10;
                const textOffsetY = 5;

                const textX = x2 + textOffsetX * Math.cos(angleRad) - textOffsetY * Math.sin(angleRad);
                const textY = y2 + textOffsetX * Math.sin(angleRad) + textOffsetY * Math.cos(angleRad);

                svg.append("text")
                    .attr("x", textX)
                    .attr("y", textY)
                    .attr("fill", color)
                    .attr("font-size", "10px")
                    .attr("text-anchor", "middle")
                    .attr("alignment-baseline", "middle")
                    .attr("font-weight", "bold")
                    .attr("stroke", "white")
                    .attr("stroke-width", "2px")
                    .attr("stroke-opacity", "0.7")
                    .attr("paint-order", "stroke")
                    .text(label);
            }

            function calcCurrentAngle(voltageAngleDeg, cosPhi) {
                const phiRad = Math.acos(Math.abs(cosPhi));
                const phiDeg = phiRad * 180 / Math.PI;
                if (cosPhi === 0) {
                    return voltageAngleDeg + phiDeg;                    
                }
                const sign = Math.sign(cosPhi)
                return voltageAngleDeg + sign * phiDeg;
                
            }

            addDegreeMarks();            

            function calcU(U, Umax) {               
                return Umax * (U / Umax * 0.95)
            }

            function calcI(I, Imax, Umax) {
                return Umax * (I / Imax * 0.7)
            }
            const circles = generateCircles(Umax)
            _voltageScale = 148.8 / Math.max(...circles);

            if (data.Ua) drawVector(calcU(data.Ua, Umax) * _voltageScale, 0, "orange", "Ua", 2);
            if (data.Ub) drawVector(calcU(data.Ub, Umax) * _voltageScale, 120, "green", "Ub", 2);
            if (data.Uc) drawVector(calcU(data.Uc, Umax) * _voltageScale, 240, "red", "Uc", 2);


            if (data.Ia) drawVector(calcI(data.Ia, Imax, Umax) * _voltageScale, calcCurrentAngle(0, data.cosPhiA), "orange", "Ia", 2.8);
            if (data.Ib) drawVector(calcI(data.Ib, Imax, Umax) * _voltageScale, calcCurrentAngle(120, data.cosPhiB), "green", "Ib", 2.8);
            if (data.Ic) drawVector(calcI(data.Ic, Imax, Umax) * _voltageScale, calcCurrentAngle(240, data.cosPhiC), "red", "Ic", 2.8);

            
            circles.forEach(r => {
                svg.append("circle")
                    .attr("cx", centerX)
                    .attr("cy", centerY)
                    .attr("r", (r * _voltageScale).toFixed(0))
                    .attr("fill", "none")
                    .attr("stroke", "#ccc")
                    .attr("stroke-dasharray", "2,2");
                svg.append("text")
                    .attr("x", centerX + 5)
                    .attr("y", centerY - (r * _voltageScale).toFixed(0) + 12)
                    .attr("font-size", "10px")
                    .attr("stroke", "white")
                    .attr("stroke-width", "2px")
                    .attr("stroke-opacity", "0.7")
                    .attr("paint-order", "stroke")
                    .text(`${(r).toFixed(0)} В`);
            });

            function generateCircles(target) {
                let maxNumber;

                // Умное округление в зависимости от размера числа
                if (target <= 10) {
                    maxNumber = Math.ceil(target / 10) * 10;
                } else if (target <= 100) {
                    maxNumber = Math.ceil(target / 10) * 10;
                } else if (target <= 1000) {
                    // Для чисел до 1000 округляем до ближайшего кратного 50
                    maxNumber = Math.ceil(target / 50) * 50;
                } else {
                    maxNumber = Math.ceil(target / 1000) * 1000;
                }

                const steps = [1, 10, 50, 100];

                // Найти подходящий шаг
                let selectedStep = 1;
                for (let step of steps) {
                    let count = Math.floor(maxNumber / step) + 1;
                    if (count <= 10) {
                        selectedStep = step;
                        break;
                    }
                }

                if (Math.floor(maxNumber / selectedStep) + 1 > 10) {
                    selectedStep = Math.ceil(maxNumber / 9);
                }

                // Особый случай: если target = 9, принудительно установить шаг = 1
                if (target <= 9) {
                    selectedStep = 1;
                }

                let result = [];
                let current = 0;

                while (current <= maxNumber && result.length < 10) {
                    result.push(current);
                    current += selectedStep;
                }

                return result;
            }            


        }
    }
    return instance;
}();